// extracted by css-extract-rspack-plugin
export default {"grid":"grid-sFCVXC","cell":"cell-NO5Rym"};